import { render, staticRenderFns } from "./task-info.vue?vue&type=template&id=71cdfd89&scoped=true&"
import script from "./task-info.vue?vue&type=script&lang=ts&"
export * from "./task-info.vue?vue&type=script&lang=ts&"
import style0 from "./task-info.vue?vue&type=style&index=0&id=71cdfd89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdfd89",
  null
  
)

export default component.exports